import { render } from "./DeleteProductsModal.vue?vue&type=template&id=653365d7"
import script from "./DeleteProductsModal.vue?vue&type=script&lang=js"
export * from "./DeleteProductsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__